import onLogin from './onLogin';
import settings from './settings';
import users from './users';
import ab from './ab';
import platformStorage from './platformStorage';
import { petActions } from '../../pet/pet.actions';
import * as PetChatbot from '../../petChatbot';
import { petChatbotActions } from '../../petChatbot/petChatbot.actions';
import * as Conversation from '../../conversation';
import { conversationActions } from '../../conversation/conversation.actions';
import { careActions } from '../../care/care.actions';
import * as Tutorial from '../../tutorial';
import { tutorialActions } from '../../tutorial/tutorial.actions';
import { socialActions } from '../../social/social.actions';
import * as Inventory from '../../inventory';
import { inventoryActions } from '../../inventory/inventory.actions';
import { profileActions } from '../../profile/profile.actions';
import * as Admin from '../../admin';
import adminActions from '../../admin/admin.actions';
import * as Gifts from '../../gifts';
import giftsActions from '../../gifts/gifts.actions';
import * as Level from '../../level';
import { levelActions } from '../../level/level.actions';
import { encyclopediaActions } from '../../encyclopedia/encyclopedia.actions';
import { visitActions } from '../../visit/visit.actions';
import { iapActions } from '../../iap/iap.actions';
import * as Duo from '../../duo';
import duoActions from '../../duo/duo.actions';
import { nativeActions } from '../../native/native.actions';
import cheats from '../../cheats/cheats.actions';
import decorationActions from '../../decoration/decoration.actions';
import daycareActions from 'src/replicant/daycare/daycare.actions';
import promoActions from 'src/replicant/promo/promo.actions';
import { catalogActions } from 'src/replicant/catalog/catalog.actions';
import { accessoryActions } from 'src/replicant/accessory/accessory.actions';
import { match2Actions } from 'src/replicant/match2/match2.actions';
import { chatbotActions } from 'src/replicant/chatbot/chatbot.actions';
import analyticsActions from 'src/replicant/analytics/analytics.actions';
import { teamActions } from 'src/replicant/team/team.actions';
import { streakBattleRoyaleActions } from 'src/replicant/streakbattleroyale/streakbattleroyale.actions';
import marketingActions from 'src/replicant/marketing/marketing.actions';
import friendsActions from 'src/replicant/friends/friends.actions';
import { resurrectionActions } from 'src/replicant/resurrection/resurrection.actions';
import adsActions from 'src/replicant/ads/ads.actions';
import statsActions from 'src/replicant/stats/stats.actions';
import { gachaActions } from 'src/replicant/gacha/gacha.actions';
import { cardsActions } from 'src/replicant/cards/cards.actions';
import { demoActions } from 'src/replicant/demo/demo.actions';
import onBeforeEntryFinal from './onBeforeEntryFinal';
import { superLollipopActions } from 'src/replicant/superLollipop/superLollipop.actions';
import { leaderboardsActions } from 'src/replicant/weeklyLeaderboard/weeklyLeaderboard.actions';
import { treasureExpressActions } from 'src/replicant/treasureExpress/treasureExpress.actions';
import { championsLeagueActions } from 'src/replicant/championsLeague/championsLeague.actions';
import { guestActions } from 'src/replicant/guest/guest.actions';
import { rescueLevelActions } from 'src/replicant/rescueLevel/rescueLevel.actions';
import { buddiesActions } from 'src/replicant/buddies/buddies.actions';
import { buddiesCheats } from 'src/replicant/buddies/buddies.cheats';
import { jankenActions } from 'src/replicant/janken/janken.actions';
import { dreamDriftActions } from 'src/replicant/dreamDrift/dreamDrift.actions';

export default {
  ...petActions,
  ...petChatbotActions,
  ...conversationActions,
  ...careActions,
  ...tutorialActions,
  ...socialActions,
  ...inventoryActions,
  ...profileActions,
  ...adminActions,
  ...giftsActions,
  ...levelActions,
  ...encyclopediaActions,
  ...visitActions,
  ...iapActions,
  ...duoActions,
  ...nativeActions,
  ...decorationActions,
  ...daycareActions,
  ...promoActions,
  ...catalogActions,
  ...accessoryActions,
  ...match2Actions,
  ...chatbotActions,
  ...teamActions,
  ...friendsActions,
  ...streakBattleRoyaleActions,
  ...statsActions,
  ...gachaActions,
  ...ab,
  ...onLogin,
  ...onBeforeEntryFinal,
  ...settings,
  ...users,
  ...platformStorage,
  ...analyticsActions,
  ...marketingActions,
  ...resurrectionActions,
  ...adsActions,
  ...cardsActions,
  ...demoActions,
  ...superLollipopActions,
  ...leaderboardsActions,
  ...treasureExpressActions,

  ...championsLeagueActions,
  ...guestActions,
  ...rescueLevelActions,
  ...jankenActions,

  ...buddiesActions,
  ...dreamDriftActions,

  ...(process.env.IS_DEVELOPMENT ? cheats : ({} as typeof cheats)),
  ...(process.env.IS_DEVELOPMENT
    ? buddiesCheats
    : ({} as typeof buddiesCheats)),
};
